// Elenco dei 30 marchi coinvolti nel richiamo airbag Takata (elenco MIT).
// `nome` deve combaciare (a meno di maiuscole) con l'elenco backend (wmiRegistry
// MARCHE_TAKATA). `slug` = file logo in /images/takata-marchi/<slug>.jpg (se assente,
// la pagina mostra un fallback testuale).
export interface MarcaTakata {
  nome: string;
  slug?: string;
}

export const MARCHE_TAKATA: MarcaTakata[] = [
  { nome: 'Audi', slug: 'audi' },
  { nome: 'BMW', slug: 'bmw' },
  { nome: 'Chrysler', slug: 'chrysler' },
  { nome: 'Citroen', slug: 'citroen' },
  { nome: 'Daihatsu', slug: 'daihatsu' },
  { nome: 'Daimler Truck' },
  { nome: 'Dodge', slug: 'dodge' },
  { nome: 'DS' },
  { nome: 'Ferrari' },
  { nome: 'Ford', slug: 'ford' },
  { nome: 'Honda', slug: 'honda' },
  { nome: 'Jaguar', slug: 'jaguar' },
  { nome: 'Jeep', slug: 'jeep' },
  { nome: 'Lancia' },
  { nome: 'Land Rover', slug: 'land_rover' },
  { nome: 'Lexus', slug: 'lexus' },
  { nome: 'Mazda', slug: 'mazda' },
  { nome: 'Mercedes-Benz', slug: 'mercedes' },
  { nome: 'Mitsubishi', slug: 'mitsubishi' },
  { nome: 'Nissan', slug: 'nissan' },
  { nome: 'Opel', slug: 'opel' },
  { nome: 'Peugeot', slug: 'peugeot' },
  { nome: 'Ram' },
  { nome: 'Seat', slug: 'seat' },
  { nome: 'Skoda', slug: 'skoda' },
  { nome: 'Subaru', slug: 'subaru' },
  { nome: 'Suzuki', slug: 'suzuki' },
  { nome: 'Tesla' },
  { nome: 'Toyota', slug: 'toyota' },
  { nome: 'Volkswagen', slug: 'volkswagen' },
];
